// extracted by mini-css-extract-plugin
export default {"cta":"hH-z","disabled":"iH-z"};